/** 顶部品牌区（LOGO + 标语），单位 px */
export const JoinBrandConfig = {
  logoSizePx: 80,
  logoMarginRightPx: 10,
  nameFontSizePx: 30,
  descFontSizePx: 24,
  toContentGapPx: 60,
} as const

/** 左侧「第一次使用…」标题区 */
export const JoinHeadingConfig = {
  fontSizePx: 20,
  toFirstCardGapPx: 30,
} as const

/** 三张操作卡片 */
export const JoinCardConfig = {
  widthPx: 375,
  heightPx: 90,
  titleFontSizePx: 16,
  subtitleFontSizePx: 14,
  iconHeightPx: 80,
  iconMarginRightPx: 20,
  titleSubtitleGapPx: 10,
} as const

/** 右侧宣传图 */
export const JoinBannerConfig = {
  imageSrc: '/ads/4.png',
  imageWidthPx: 420,
} as const

/** 卡片说明弹框 */
export const JoinTipModalConfig = {
  widthPx: 460,
  heightPx: 300,
  titleFontSizePx: 20,
  bodyFontSizePx: 18,
} as const

export type JoinTipKey = 'joinExisting' | 'createTemp' | 'createEnterprise'

/** 卡片左侧图标（public/ads，与 JoinTipKey 顺序对应 1、2、3） */
export const JoinCardIconSrc: Record<JoinTipKey, string> = {
  joinExisting: '/ads/1.png',
  createTemp: '/ads/2.png',
  createEnterprise: '/ads/3.png',
}

export const JoinTipTitle: Record<JoinTipKey, string> = {
  joinExisting: '加入一个已有的团队/企业',
  createTemp: '创建临时服务团队',
  createEnterprise: '为企业创建一个新团队',
}

export const JoinTipContent: Record<JoinTipKey, string> = {
  joinExisting:
    '如果您的企业让您加入团队，请联系您想加入的团队的管理员，让其添加自己到企业团队中。如果你是和别的卖家一起承接项目的，请联系这位卖家，让其添加自己到团队中。',
  createTemp:
    '当你需要和多个卖家一起承接中大型项目时，您可以联系圆领平台人员创建一个临时团队，用来更好的服务客户，客户也可以在麻雀中很便捷的了解你们的工作进展。',
  createEnterprise:
    '如果您购买了圆领自营的按月承揽类产品，可以免费创建最多3个团队，每个团队中非圆领成员数量要<=圆领成员数量；超过限额时，每人每月30元使用费。详情请咨询圆领客服。',
}
